<section class="collapse-card--container" #collapseCard>
    <div class="collapse--wrapper {{isCollapse ? 'collapsed': ''}}" [ngStyle]="{'height': viewHeight+'px'}">
        <header class="collapse--header">
            <span class="header--title">{{header}}</span>
            <div (click)="toggleCollapse()" class="collapse--button {{isCollapse ? 'collapsed' : ''}}"><i class="fas fa-chevron-up"></i></div>
        </header>
        <div class="collaspe--content">
            <ng-content></ng-content>
        </div>
    </div>
</section>